import styled from 'styled-components';
import media from '../../base/media';
import { StyledButton } from '../../base';

export const Wrapper = styled.div`

`;

export const ButtonWrapper = styled.div`
	margin-top: 6rem;
	text-align: center;

	${media.mobileOnly`
		${StyledButton} {
			white-space: initial;
			padding: 2rem;
			height: auto;
		}
	`}

	${media.tabletOnly`
		${StyledButton} {
			white-space: initial;
			padding: 2rem;
			height: auto;
		}
	`}
`;

export const CheckBoxWrapper = styled.div`
	margin-top: 6rem;
`;
